// @flow

type PropsType = {
    $element: HTMLElement,
};

class FooterPrimaryLink {
    props: PropsType;
    $el: HTMLElement;
    href: string;

    constructor(props: PropsType) {
        this.$el = props.$element;
        this.href = this.$el.getAttribute("href");

        this.init();
    }

    init() {
        const comp = new RegExp(document.location.host);
        const live = new RegExp("www.vaxiplace.com.au");

        if (
            this.href &&
            !comp.test(this.href) &&
            !live.test(this.href) &&
            (this.href.indexOf("http://") > -1 ||
                this.href.indexOf("https://") > -1)
        ) {
            const newElement = document.createElement("i");
            newElement.setAttribute(
                "class",
                "icon icon-exit text-button__icon"
            );
            newElement.setAttribute("aria-label", "hidden");
            this.$el.appendChild(newElement);
        }
    }
}

export default FooterPrimaryLink;
